import { c as _c } from "react/compiler-runtime";
import React from 'react';
const SpecificTriggerRuleError = t0 => {
  const $ = _c(2);
  const {
    error
  } = t0;
  let t1;
  if ($[0] !== error) {
    t1 = error ? <div className="bg-bg-accent border-border-accent text-text-primary rounded-lg border p-5">{error}</div> : null;
    $[0] = error;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export default SpecificTriggerRuleError;